//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState, mapMutations} from 'vuex'
import Menu from '../../components/menu/Menu.vue'
import Norm from '../../components/card/norm.vue'
import Code from '../../components/card/GoodCode.vue'
import Count from '../../components/cart/Count.vue'
import CartBtn from '../../components/cart/CartBtn.vue'
import {goodProduct, getProductPic, addCart, campaignRule} from '../../service/index'
import {productCombine} from '../../utils/storage'

export default {
  name: 'GoodDetail',
  data() {
    return {
      spec: null,
      productPic: [],
      products: {},
      select: 0,
      count: 1,
      rule:{}
    }
  },
  components: {
    Menu, Norm, Code, Count, CartBtn
  },
  created() {
    this.changeVisible()
    this.keepLang()
    this.getCampaignRuleInfo()
  },
  computed: {
    ...mapState([
      'categories', 'cartList', 'campaign', 'global'
    ]),
    product() {
      return this.productAndPic.length > 0 ? this.productAndPic[this.select] : {}
    },
    productAndPic() {
      const result = [];
      this.productPic && this.productPic.map((item) => {
        this.products.map((good) => {
          if (item.goodId === good.goodId) {
            result.push({...item, ...good})
          }
        })
      })
      return result;
    },
    bread() {
      let locale = localStorage.locale;
      const zhBread = locale === 'zh' ? [{name: 'Home'}] : [{name: 'Home'}]
      this.categories.length && this.categories.map((item) => {
        if (item.id === this.product.productTypeId) {
          zhBread.push(item)
          item.children.map(cat => {
            if (cat.id === this.product.productCategoryId) {
              zhBread.push(cat)
            }
          })
        }
      })
      zhBread.push(locale === 'zh' ? {name : this.product.name} : {name: this.product.enName} )
      return zhBread;
    }
  },
  methods: {
    ...mapMutations({
      initCart: 'INIT_CART_NUM',
      changePage: 'CHANGE_PAGE'
    }),
    async getCampaignRuleInfo() {
      const res = await campaignRule(this.$route.query.cid);
      if (res.status === 0) {
        this.rule = res.data
      }
    },
    clearFocus(self){
      window.document.activeElement.blur()
    },
    async changeVisible() {
      const goodId = this.$route.query.id;
      const products = await goodProduct(goodId);
      this.spec = productCombine(products.data);
      this.products = products.data;
      const productPicture = await getProductPic(goodId)
      this.productPic = productPicture.data;
      this.isShow = true
    },
    async addProToCart(goodId) {
      const param = {
        "items": [
          {
            "productId": goodId,
            "qty": this.count
          }
        ]
      }
      const res = await addCart(this.$route.query.cid, param);
      if (res.status === 0) {
        this.initCart({
          cartNum: this.count + this.cartList.cartNum,
        })

        this.$message({
          message: this.$t('cartMsg.'+res.status),
          type: 'success'
        });
        // this.$
        // let elLeft = event.target.getBoundingClientRect().left;
        // let elBottom = event.target.getBoundingClientRect().bottom;
        // this.showMoveDot.push(true);
        // this.$emit('showMoveDot', this.showMoveDot, elLeft, elBottom);
      }else {
        if (res.status !== 2) {
          this.submitFlag = false;
        }
        const message = this.$t("cartMsg."+res.status);
        if(message !== null && message !== "cartMsg."+res.status){
          this.$message(message);
        }else {
          this.$message(this.$t("cartMsg.retry"));
        }
      }
    },
    doLink(item, index){
      const length = this.bread.length;
      if(index !== length){
        this.changePage(1)
        if(index === 0){
          this.$router.push({
            path: `/home/${this.$route.query.cid}`,
            query: { cid: this.$route.query.cid}
          })
        }else if(index === 1){
          this.$router.push({
            path: `/home/${this.$route.query.cid}`,
            query: { cid: this.$route.query.cid, type: item.id }
          })
        }else if(index === 2){
          this.$router.push({
            path: `/home/${this.$route.query.cid}`,
            query: { cid: this.$route.query.cid, type: item.productTypeId, cat: item.id }
          })
        }
      }
    },
    keepLang(){
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/good/Detail.vue